import React from 'react'
import {
  AppWrapper,
  FunnelPage,
  CTAButton,
  FlexBox,
  FlexDirection,
  ComponentColor,
  Grid,
  Columns,
  JustifyContent,
  InfluxDBCloudLogo,
  InfluxColors,
  Icon,
  IconFont,
} from '@influxdata/clockface'
import MarketplaceHeader from './MarketplaceHeader'

interface Props {
  signupUrl: string
}

const close_and_open = (signupUrl) => {
  window.open(signupUrl, '_blank')
  window.close()
}

const ClosePopup = ({signupUrl}: Props): JSX.Element => {
  return (
    <AppWrapper type="funnel" className="marketplace-splash">
      <FunnelPage
        logo={
          <InfluxDBCloudLogo
            fill={InfluxColors.White}
            cloud={true}
            className="influx-cloud-logo"
          />
        }
      >
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <MarketplaceHeader
              header="Get Started in a New Browser Window"
              subtitle="Set up an InfluxDB Cloud Account to activate your Google Cloud Subscription"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <div className="close-popup--graphic" />
        </Grid.Row>
        <Grid.Row>
          <FlexBox
            direction={FlexDirection.Column}
            justifyContent={JustifyContent.Center}
            className="splash--cta-button"
          >
            <p>
              Next: <strong>Create Account</strong>
            </p>
            <CTAButton
              onClick={() => close_and_open(signupUrl)}
              text="Continue"
              color={ComponentColor.Primary}
            />
          </FlexBox>
        </Grid.Row>
        <FunnelPage.Footer className="close-popup--footer">
          <FunnelPage.FooterSection>
            <span>Powered by</span> <Icon glyph={IconFont.CuboUniform} />
            <a href="https://www.influxdata.com/" target="_blank">
              InfluxData
            </a>
          </FunnelPage.FooterSection>
        </FunnelPage.Footer>
      </FunnelPage>
    </AppWrapper>
  )
}

export default ClosePopup
